export default __webpack_public_path__ + "locales/ar-SA/People.json?hash=1100274b6497bafe504104c162ecfda5";